import { Modal, Button } from "react-bootstrap";

import React, { useState } from "react";

export type ForgotPasswordProps = {
    show: boolean;
    username: string;
    onOk: () => void;
    onClose: () => void;
};

export default function ForgotPasswordModal({
    show,
    username,
    onOk,
    onClose,
}: ForgotPasswordProps) {
    const [isChecked, setIsChecked] = useState(false);

    return (
        <Modal
            size="lg"
            aria-labelledby="child-modal-title-vcenter"
            centered
            style={{
                border: "2px solid #000",
            }}
            show={show}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Reset Password
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Warning:</h4>
                <p
                    style={{
                        fontSize: "14px",
                    }}
                >
                    Are you sure you want to reset your password?
                </p>

                <ul>
                    <li>
                        {" "}
                        This will send a verification code to the address on
                        file for this user.
                    </li>
                    <li>
                        Make sure you can receive email at that address and
                        check your SPAM folder for the verification code email.
                    </li>
                    <li>
                        {" "}
                        THE LINK IS ONLY ACTIVE FOR 30 MINUTES. If you do not
                        verify the password reset within 30 minutes you will
                        need to request a new link.{" "}
                    </li>
                    <li>
                        If you do not receive an email you must check with your
                        IT department as the email is being blocked by rules or
                        a firewall.
                    </li>
                </ul>

                <div className="row">
                    <div className="col-lg-20">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="btnYesRelatedCases"
                            name="relatedCases"
                            checked={isChecked}
                            onChange={(e) => {
                                setIsChecked(!isChecked);
                            }}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="btnYesRelatedCases"
                            style={{ paddingLeft: "5px" }}
                        >
                            {"   "} I have read the above and acknowledge I will
                            be resetting my password according to these
                            instructions.
                        </label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-primary waves-effect waves-light"
                    type="button"
                    onClick={onClose}
                >
                    Cancel
                </button>
                {isChecked == true ? (
                    <button
                        className="btn btn-danger waves-effect waves-light"
                        type="button"
                        onClick={onOk}
                    >
                        Continue
                    </button>
                ) : (
                    <button
                        className="btn btn-danger waves-effect waves-light"
                        type="button"
                        disabled={true}
                    >
                        Continue
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
}
